import { useState, useEffect } from 'react';
import { Form, Image, Typography, Alert } from 'antd';
import CustomInput from '../../components/CustomInput/Input';
import CustomButton from '../../components/CustomButton/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from "../../assets/images/auth-logo.png";
import { setNewPassword, clearAuthError } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { confirmPasswordRules, passwordRules } from '../../helpers/helpers';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import CryptoJS from 'crypto-js';
import { BTN_TXT, TITLE_TXT } from '../../constants/constants';

const { Title } = Typography;

const ChangePassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { reset_token } = location.state || {};
    const [visible, setVisible] = useState(false);
    const { loading, error } = useSelector((state) => state.auth);
    const [form] = Form.useForm();

    useEffect(() => {
        return () => {
            dispatch(clearAuthError());
        };
    }, [dispatch]);

    const toggleVisibility = () => {
        setVisible(!visible);
    };

    const onFinish = async (values) => {
        const hashedPassword = CryptoJS.SHA256(values.enterPassword).toString();


        const payload = {
            reset_token,
            password: hashedPassword
        }

        const res = await dispatch(setNewPassword(payload))

        if (res.payload.statusCode === 200) {
            navigate('/login')
        }

    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-logo-container">
                <Image preview={false} src={Logo} alt="Logo" />
            </div>
            <div className="forgot-password-card-container">
                <Title level={2}>{TITLE_TXT.CHNG_PWD_TITLE}</Title>
                <Form
                    form={form}
                    layout="vertical"
                    className="forgot-form"
                    onFinish={onFinish}
                    initialValues={{ remember: true }}
                >
                    <CustomInput
                        label="Enter New Password"
                        name="enterPassword"
                        type={visible ? "text" : "password"}
                        isPassword={true}
                        iconRender={(visible) =>
                            visible ? (
                                <EyeInvisibleOutlined onClick={toggleVisibility} />
                            ) : (
                                <EyeOutlined onClick={toggleVisibility} />
                            )
                        }
                        placeholder="Enter Password"
                        rules={passwordRules}
                    />

                    <CustomInput
                        label="Confirm New Password"
                        name="confirmPassword"
                        type={visible ? "text" : "password"}
                        isPassword={true}
                        iconRender={(visible) =>
                            visible ? (
                                <EyeInvisibleOutlined onClick={toggleVisibility} />
                            ) : (
                                <EyeOutlined onClick={toggleVisibility} />
                            )
                        }
                        placeholder="Re-enter Password"
                        rules={confirmPasswordRules}
                    />
                    {error && <Alert style={{ marginTop: 20 }} message={error} type="error" showIcon />}
                    <Form.Item>
                        <CustomButton
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            style={{ marginTop: 20, padding: 24 }}
                        >
                            {BTN_TXT.SUBMIT}
                        </CustomButton>
                    </Form.Item>
                    <Form.Item>
                        <CustomButton
                            type="text"
                            block
                            style={{ fontWeight: 600, padding: 0 }}
                            onClick={() => navigate(-1)}
                        >
                            {BTN_TXT.BACK}
                        </CustomButton>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default ChangePassword;
